<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
* { margin: 0; padding: 0; box-sizing: border-box; }
html, body, #app { height: 100%; font-family: 'Helvetica Neue', Helvetica, 'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei', Arial, sans-serif; font-size: 16px; }

/* 表格占满整行 */
.el-table { width: 100% !important; }
.el-card { width: 100%; }

/* 整体字体放大 */
body { font-size: 16px; }
.el-table td, .el-table th { font-size: 15px !important; padding: 12px 0 !important; }
.el-table th { font-size: 15px !important; font-weight: 600; }
.el-button { font-size: 15px; padding: 10px 20px; }
.el-button--mini { font-size: 14px; padding: 7px 15px; }
.el-form-item__label { font-size: 15px; }
.el-input__inner { font-size: 15px; }
.el-textarea__inner { font-size: 15px; }
.el-dialog { font-size: 15px; }
.el-dialog__title { font-size: 18px; }
.el-menu { font-size: 15px; }
.el-menu-item, .el-submenu__title { font-size: 15px; height: 48px; line-height: 48px; }
.el-pagination { font-size: 14px; }
.el-tag { font-size: 13px; }
.el-select .el-input__inner { font-size: 15px; }
</style>
